__turbopack_context__.v({
  "className": "inter_90b2603d-module__Njgyaq__className",
  "variable": "inter_90b2603d-module__Njgyaq__variable",
});
